import Navigation from "../../components/Navigation/Navigation";
import SecondaryNavigation from "../../components/SecondaryNavigation/SecondaryNavigation"
import Table from "../../components/Table/Table";
import { useState, useEffect, useContext, useRef, useMemo } from "react";
import { context, } from '../../context/authContext';
import useApi from '../../helpers/api';
import Loader from "../../components/Loader/Loader";
import useColumns from './columns';
import useActions from './acciones';
import ConfirmModal from "../../components/Modal/Modal.js"
import './validations.css'


export default function Usuarios() {
  const [data, setData] = useState(null);
  const [roles, setRoles] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const { handleLogout, user } = useContext(context);
  const gridRef = useRef();
  const [selectedRow, setSelectedRow] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const  columnDefs  = useColumns(setSelectedRow,setModalOpen,roles,empresas);
  const { createHook, onCellEditingStopped, confirmDelete } = useActions();
  const api = useApi();

  const canCreate = useMemo(() => ({
    canCreate: Array.isArray(user?.rol) 
      ? user.rol.some(m => m.nombre === "Usuarios" && m.permiso.includes("crear")) 
      : false,
    button: "Crear usuario"
  }), [user?.rol]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.getUsuarios();
        if (response?.response?.data?.error) {
          handleLogout();
          return;
        }
        setData(response)
        const rolesApi = await api.getRoles();
        setRoles(rolesApi)
        const empresasApi = await api.getEmpresas();
        setEmpresas(empresasApi)
      } catch (err) {
        handleLogout();
      }
    };

    fetchData();  
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleLogout]);

  return (
    <>
      <Navigation />
      <SecondaryNavigation title="Usuarios" />
      {!!data ? 
        <Table 
        columns={columnDefs} 
        data={data}
        onCellEditingStopped={onCellEditingStopped}
        canCreate={canCreate}
        createHook={createHook}
        gridRef={gridRef}
        />
      :
        <Loader/>
      }
      <ConfirmModal
        isOpen={modalOpen}
        tipo= "confirmacion"
        message={`Are you sure you want to delete ${selectedRow?.data.nombre}?`}
        onConfirm={()=>confirmDelete(gridRef, selectedRow, setModalOpen, setSelectedRow)}
        onCancel={() => setModalOpen(false)}
      />
    </>
  );
}